// useEchoListener.js
import { useEffect } from "react";
import { listenToChannel } from "../common/ws/connection";

export default function useEchoListener({
  channel,
  event,
  handler,
  enabled = true,
  deps = [],
}) {
  useEffect(() => {
    if (!enabled) return;

    const cleanup = listenToChannel({
      channel,
      event,
      callback: handler,
    });

    return cleanup;
  }, [enabled, channel, event, ...deps]);
}